module.exports = __webpack_public_path__ + "static/media/gate.fc4b5a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/gate.png
// module id = 2305
// module chunks = 0